<template>
  <section class="mworks">
    <m-title-bg></m-title-bg>
    <a-select class="mworks-select" v-model="selectProfession" @change="redirectTo">
      <a-select-option :value="item.id" v-for="(item, index) in selectList" :key="index">{{item.domain_name}}</a-select-option>
    </a-select>
    <div class="mworks-filter">
      <span class="mworks-filter-icon"></span>
      <a-input placeholder="请输入要搜索的内容" v-model="defaultValue" @keyup.enter.native="search"></a-input>
      <a-button type="primary" class="mworks-filter-button" @click="search">确定</a-button>
    </div>
    <a-button type="primary" class="mworks-upload" @click="bindUploadBtn">
      <img src="../../../assets/image/add-icon.png" alt="" class="mworks-upload-icon">
      作品上传
    </a-button>
    <a-spin :spinning="loading" tip="Loading..." :delay="500" style="min-height: 70px;">
    <ul class="mworks-list">
      <m-grand-works-item v-for="(item, index) in dataListAll" :key="index" :grandInfo="item"></m-grand-works-item>
    </ul>
    <a-button class="mworks-more" type="primary" @click="loadMore" v-if="showLoad">加载更多</a-button>
    </a-spin>
  </section>
</template>
<script>
import MTitleBg from '../../../components/mobile/MTitleBg'
import MGrandWorksItem from '../../../components/mobile/MGrandWorksItem'
import { GrandWorks } from '../../../common/garden/GrandWorks'
export default {
  mixins: [GrandWorks,],
  components: {
    MTitleBg,
    MGrandWorksItem
  },
  data () {
    return {
      selectProfession: "0",
      selectList: [{domain_name: "全部专业", id: "0"}],
    }
  },
  mounted() {
    var url = this.$root.apiBaseUrl + '?g=api&m=api&a=domain_list_api';
    this.$http.get(url).then(function (response) {
        if (response.body.status == 1) {
          this.selectList = response.body.data;
          this.selectList.unshift({domain_name: "全部专业", id: "0"});
          var index = this.selectList.findIndex(item => item.id == this.domainId);
          index = -1 == index ? 0 : index;
          this.selectProfession = this.selectList[index].id;
        }
      }, function (reserror) {
        console.log(reserror);
      })
  },
  computed: {
    showLoad() {
      return this.currentPage < this.totalPage;
    },
  },
  methods: {
    // 点击作品上传
    bindUploadBtn () {
      this.$router.push('/my/uploadworks')
    },
    loadMore() {
      this.currentPage += 1;
      this.getData();
    },
    redirectTo() {
      if(this.selectProfession > 0) {
        this.$router.push('/main/grandworks?domain_id='+this.selectProfession);
      } else {
        this.$router.push('/main/grandworks');
      }
    }
  }
}
</script>
<style lang="less" scoped>
.mworks{
  overflow: hidden;
  & /deep/ .ant-select{
    margin: 4.27vw 0 4vw;
    width: 100%;
    height: 10.67vw;
    &-selection{
      height: 10.67vw;
      &__rendered{
        height: 10.67vw;
        line-height: 10.67vw;
      }
    }
  }
  &-filter{
    display: flex;
    align-items: center;
    margin-bottom: 4vw;
    height: 10.67vw;
    width: 100%;
    background: #fff;
    border: 0.13vw solid #D1D1D1;
    border-radius: 0.67vw;
    overflow: hidden;
    &-icon{
      flex-shrink: 0;
      border-right: 0.13vw solid #D1D1D1;
      width: 9.6vw;
      height: 10.67vw;
      background: url('../../../assets/image/search-icon.png') no-repeat center center;
      background-size: 4.93vw 4.13vw;
    }
    & /deep/ .ant-input{
      flex-grow: 1;
      font-size:3.47vw;
      font-weight:400;
      color:rgba(0,0,0,1);
      height: 10.67vw;
      line-height: 10.67vw;
      border: none;
    }
    &-button{
      flex-shrink: 0;
      height: 10.67vw;
      width: 18.67vw;
      border-radius: 0 0.67vw 0.67vw 0;
    }
  }
  &-upload{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 5.33vw;
    width: 100%;
    height:10.67vw;
    background:rgba(193,102,19,1);
    border-radius:0.67vw;
    &-icon{
      margin-right: 1.6vw;
      width: 4vw;
      height: 4vw;
    }
  }
  &-list{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  &-more{
    margin: 4.67vw 0 6.67vw;
    width: 100%;
    height:10.67vw;
    font-size:3.47vw;
    font-weight:300;
    color:rgba(102,102,102,1);
    background:rgba(241,241,241,1);
    border:0.13vw solid rgba(204,204,204,1);
    border-radius:1.33vw;
  }
}
</style>
